module.exports = __webpack_public_path__ + "img/15-qlgydx.2150261e.png";